import { DefaultLocale } from '@lib/utils/localeHelpers'
import { useParams } from 'next/navigation'

export const useLocale = (): string => useParams<{ locale: string }>().locale ?? DefaultLocale.FALLBACK
